import BaseSerializer from './Base';
import {toSize} from 'ol/size';
import TileImage from 'ol/source/TileImage';

class TileImageSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = TileImage;
    }

    serialize(layer, source) {
        this.validateSource(source);
        let tileGrid = source.getTileGrid();
        let serialized = {
            baseURL: source.getUrls()[0],
            opacity: layer.getOpacity(),
            imageExtension: 'png', //source.getFormat() ||
            resolutions: tileGrid.getResolutions(),
            tileSize: toSize(tileGrid.getTileSize()),
            type: 'OSM'
        };
        return serialized;
    }

    validateSource(source) {
        if (!(source instanceof this.sourceCls)) {
            this.raiseException('Cannot serialize this source with this serializer');
        }
        if (source.getUrls() === null) {
            this.raiseException('Cannot serialize this source without an URL. ' +
                'Usage of tileUrlFunction is not yet supported');
        }
    }
};

export default TileImageSerializer;